export default {
  methods: {
    isAssetIcon: (icon) => /\w+[/\\.]\w+/.test(icon),
  },
};
